var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.283,
    height: 16.008,
    viewBox: "0 0 17.283 16.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-comments",
    transform: "translate(-34.9 -559.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M14.735-1.332H2.349A2.351,2.351,0,0,0,0,1.017V8.6a2.351,2.351,0,0,0,2.34,2.349v3.44l4.943-3.44h7.451A2.351,2.351,0,0,0,17.083,8.6V1.017a2.351,2.351,0,0,0-2.349-2.349ZM16.083,8.6a1.349,1.349,0,0,1-1.348,1.348H6.97L3.342,12.469V9.944H2.349A1.349,1.349,0,0,1,1,8.6V1.017A1.349,1.349,0,0,1,2.349-.331H14.735a1.349,1.349,0,0,1,1.348,1.348Zm0,0",
    transform: "translate(34.999 560.86)",
    fill: "#45338c",
    stroke: "#45338c",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M171.293,131.172h7.939v1h-7.939Zm0,0",
    transform: "translate(-131.721 431.893)",
    fill: "#45338c",
    stroke: "#45338c",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M171.293,211.172h7.939v1h-7.939Zm0,0",
    transform: "translate(-131.721 354.028)",
    fill: "#45338c",
    stroke: "#45338c",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M171.293,291.172h7.939v1h-7.939Zm0,0",
    transform: "translate(-131.721 276.164)",
    fill: "#45338c",
    stroke: "#45338c",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComments);
export default __webpack_public_path__ + "static/media/icon-comments.e0f3339b6dd268a49e3d847b7133a269.svg";
export { ForwardRef as ReactComponent };